import React from "react";
import { IoIosCheckmarkCircle } from "react-icons/io";
import { CiCircleInfo } from "react-icons/ci";
import { Link } from "react-router-dom";
import { Modal } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";

const PlanItem = ({ plan }) => {
  console.log(plan);
  const [opened, { open, close }] = useDisclosure(false);

  const {
    productDescription,
    productName,
    productCode,
    pricing,
    availableProductCoverage,
  } = plan;

  const price = Number(pricing?.premium).toFixed(2);
  const allBenefits = availableProductCoverage?.coverageDetails?.flatMap(
    (item) => item.benefits
  );
  console.log(allBenefits);
  const fourBenifits = allBenefits.slice(0, 3);
  console.log(fourBenifits);

  return (
    <div className="plan-details-wrapper">
      <Modal opened={opened} onClose={close} size={"80%"}>
        <div>
          <h1 className="benifit-title">Benifits</h1>

          {allBenefits.map((benifit, index) => {
            return (
              <div className="benifit-wrapper">
                <div className="benifit-header">
                  {index + 1}. {benifit?.description}
                </div>

                {benifit?.limit !== "N/A" && (
                  <div className="benifit-desc">Limit : {benifit?.limit}</div>
                )}
              </div>
            );
          })}
        </div>
      </Modal>
      <div className="plan-wrapper">
        <div className="plan-title-wrapper">
          <h3 className="plan-title">{productName}</h3>

          <h2 className="plan-title-price">${price}</h2>
        </div>

        <div className="plan-desc-wrapper">
          <p className="plan-desc">{productDescription}</p>

          <span className="plan-view-all-btn" onClick={open}>
            View Plan Details
          </span>
        </div>

        <div className="best-coverage-wrapper">
          <h6 className="best-coverage-title">Best Coverage</h6>

          <div className="best-coverage-list">
            {fourBenifits.map((item, index) => {
              return (
                <span className="best-coverage-list-item" key={index}>
                  <IoIosCheckmarkCircle color="green" size={"20px"} />
                  {item?.description}
                </span>
              );
            })}
          </div>

          {allBenefits.length > 4 && (
            <span className="plan-view-all-btn" onClick={open}>
              View All
            </span>
          )}
        </div>
      </div>

      <div className="plan-purchase-wrapper">
        <span className="plan-purchase-price">
          Total: <span>${price}</span> <CiCircleInfo />
        </span>

        <Link
          className="plan-purchase-btn"
          to={"/insurance/payment"}
          state={{ pricing, productCode }}
          onClick={() => {
            window.scrollTo(0, 0);
          }}
        >
          Purchase
        </Link>
      </div>
    </div>
  );
};

export default PlanItem;
